import React, { Component } from 'react'
import {
  Table,
  Button,
  ButtonToolbar
} from 'react-bootstrap'
import { connect } from 'react-redux'

class ListadoCamiones extends Component {
  renderTableHead () {
    return (
      <thead>
        <tr>
          <th>Numero</th>
          <th>Peso</th>
          <th>Localidad</th>
          <th>Exportador</th>
          <th />
        </tr>
      </thead>
    )
  }

  renderTableBody () {
    const {
      appList
    } = this.props
    return (
      <tbody>
        {appList.map((app) =>
          (<tr key={app.appNumero}>
            <td>{app.appNumero}</td>
            <td>{app.appPeso}</td>
            <td>{app.appLocalidad}</td>
            <td>{app.appExportador}</td>
            <td>
              <ButtonToolbar className='pull-right'>
                <Button
                  variant='info'
                  onClick={() => null}
                >Edit</Button>
                <Button variant='danger'
                  onClick={() => null}
                >Delete</Button>
              </ButtonToolbar>
            </td>
          </tr>))
        }
      </tbody>
    )
  }

  render () {
    return (
      <div className='cp-list'>
        <Table hover bordered responsive>
          {this.renderTableHead()}
          {this.renderTableBody()}
        </Table>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  appList: [
    {
      appNumero: 593555145,
      appPeso: '45983kg',
      appLocalidad: 'Quequen',
      appExportador: 'Exportador1 - 19999999991'
    },
    {
      appNumero: 593555146,
      appPeso: '45983kg',
      appLocalidad: 'Necochea',
      appExportador: 'Exportador1 - 19999999991'
    },
    {
      appNumero: 593545145,
      appPeso: '45983kg',
      appLocalidad: 'Quequen',
      appExportador: 'Exportador1 - 19999999991'
    },
    {
      appNumero: 5142393555145,
      appPeso: '45983kg',
      appLocalidad: 'Quequen',
      appExportador: 'Exportador1 - 19999999991'
    },
    {
      appNumero: 593551235145,
      appPeso: '45983kg',
      appLocalidad: 'Quequen',
      appExportador: 'Exportador1 - 19999999991'
    },
    {
      appNumero: 5935555652145,
      appPeso: '45983kg',
      appLocalidad: 'Quequen',
      appExportador: 'Exportador1 - 19999999991'
    },
    {
      appNumero: 5935551342345,
      appPeso: '45983kg',
      appLocalidad: 'Quequen',
      appExportador: 'Exportador1 - 19999999991'
    },
    {
      appNumero: 523493555145,
      appPeso: '45983kg',
      appLocalidad: 'Quequen',
      appExportador: 'Exportador1 - 19999999991'
    },
    {
      appNumero: 593523455145,
      appPeso: '45983kg',
      appLocalidad: 'Quequen',
      appExportador: 'Exportador1 - 19999999991'
    }
  ]
})

const withRedux = connect(mapStateToProps, {})
export default withRedux(ListadoCamiones)
